import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from 'react-router-dom';
import MiniDrawer from "../../../../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Link, useNavigate } from "react-router-dom";
// import ContentPasteSearchTwoToneIcon from "@mui/icons-material/ContentPasteSearchTwoTone";

const AvailabilityView = () => {
    // const location = useLocation();
    // const { userid } = location.state || {};
    const [userAvailabilityView, setUserAvailabilityView] = useState([]);
    const baseAPI = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const navigate = useNavigate();

    const userid = location.state.userid;
  
    useEffect(() => {
      const storedToken = JSON.parse(localStorage.getItem("token"));     
      
      if (storedToken) {
        axios
          .get(`${baseAPI}userget/GetAvailableListHistory?userId=${userid}`, {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          })
          .then((response) => {           
            setUserAvailabilityView(response.data.data);
          })
          .catch((error) => {
            console.error("Error fetching user detail:", error);
          });
      }
    },[]);

  return (
   
        <div className="d-flex flex-row app">
          <MiniDrawer />
    
          <div
            className="container-fluid"
            style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
          >
            <div
              className="d-flex flex-column w-100"
              style={{ backgroundColor: "#F4F4F4" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                    User Availability View| <HomeOutlinedIcon />{" "}
                    <span style={{ fontSize: "20px" }}>&gt; View</span>
                  </h1>
                </div>
              </div>
    
              <div
                className="container-fluid User-availability"
                style={{ margin: "2rem 0" }}
              >
                <div className="UserAvailabl">
                  <form className="UserAvailability-form">
                    <table style={{ width: "100%" }}>
                      <tr className="tableHeading">
                        <th>Activity Type</th>
                        <th>Activity Time</th>
                      </tr>
    
                      {userAvailabilityView.map((user) => (
                        <tr key={user.userid}>
                          <td>{user.activity_type}</td>
                          <td>{user.activity_time}</td>
                         
                        </tr>
                      ))}
                    </table>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };
    
 

export default AvailabilityView